module.exports = __webpack_public_path__ + "static/img/6.71641e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/3/eng/6.png
// module id = XWCH
// module chunks = 0